import React from 'react';
import ContentSection from '../ContentSection';
import Navbar from '../Navbar';
import './styles.css';


const SimplePageTemplate = (props) => (
  <Navbar location={props.location}>
    <div className="simple-page-template">
      <ContentSection className="simple-page-images" containerClassName="theme-background">
        <div className="simple-page-banner">
          <img src={props.bannerImage} alt={props.bannerAlt}/>
        </div>
        <div className="simple-page-image-row">
          <div className="simple-page-image"><img src={props.image1} alt={props.imageAlt}/></div>
          <div className="simple-page-image"><img src={props.image2} alt={props.imageAlt}/></div>
          <div className="simple-page-image"><img src={props.image3} alt={props.imageAlt}/></div>
        </div>
      </ContentSection>
      <ContentSection>
        {props.children}
      </ContentSection>      
    </div>
  </Navbar>
);

export default SimplePageTemplate;


// WEBPACK FOOTER //
// ./src/components/SimplePageTemplate/index.js